import React from 'react';
import { ReactComponent as Failure } from '../../assets/images/failure.svg';
import { ReactComponent as Suspend } from '../../assets/images/suspend-dialog-icon.svg';

function FailurePopup(props) {
  const {
    displayText = 'Error', description = 'This is Discreption', okayText = 'Close', cancelText = 'Cancel', onOkay, onCancel, show, showOkayButton, showCancelButton,
    showSuspend = false,
  } = props;
  //   const navigate = useNavigate();

  //   const handleLinkClick = () => {
  //     navigate(linkUrl);
  //   };
  return (
    show
    && (
      <>
        <div className="overlay" />
        <div className="Team-PopUp-Container-Common">
          <div className="Successful-Container">
            {showSuspend ? <Suspend /> : <Failure />}
          </div>
          <div className="Success_static_container">
            <p className="Succes_static_text">{displayText}</p>
            <p className="Succes_static_discreption">{description}</p>
          </div>
          <div className="chatLimit-button">
            {showCancelButton
            && (
              <button className="SendChat-Button" type="button" onClick={onCancel}>
                {cancelText}
              </button>
            )}
            {showOkayButton
            && (
              <button className="SendChat-Button01" type="button" onClick={onOkay}>
                {okayText}
              </button>
            )}
          </div>
          {/* {naviageUrl && (
          <div className="link-container">
            <button onClick={handleLinkClick}>{linkText}</button>
          </div>
        )} */}
        </div>
      </>
    )
  );
}

export default FailurePopup;
